import { WINDOWS_CDN_PATH } from '../../windows-constants';

export type WindowsTypeCardStructure = {
  imgSrc: string;
  modalImgSrc: string;
  title: string;
  description: string;
};

export const WINDOWS_TYPE_CARD_LIST: WindowsTypeCardStructure[] = [
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/simple.jpg/simple.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/simple.jpg/simple.jpg`,
    title: 'type-section.simple.title',
    description: 'type-section.simple.description',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/anti-burglary.jpg/anti-burglary.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/anti-burglary.jpg/anti-burglary.jpg`,
    title: 'type-section.anti-burglary.title',
    description: 'type-section.anti-burglary.description',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/noise-protection.jpg/noise-protection.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/noise-protection.jpg/noise-protection.jpg`,
    title: 'type-section.noise-protection.title',
    description: 'type-section.noise-protection.description',
 },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/energy-saving.jpg/energy-saving.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/energy-saving.jpg/energy-saving.jpg`,
    title: 'type-section.energy-saving.title',
    description: 'type-section.energy-saving.description',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/for-children.jpg/for-children.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/for-children.jpg/for-children.jpg`,
    title: 'type-section.children.title',
    description: 'type-section.children.description',
  },
  {
    imgSrc: `${WINDOWS_CDN_PATH}/types/sun-protection.jpg/sun-protection.jpg`,
    modalImgSrc: `${WINDOWS_CDN_PATH}/types-popup/sun-protection.jpg/sun-protection.jpg`,
    title: 'type-section.sun-protection.title',
    description: 'type-section.sun-protection.description',
  },
];
